// extracted by mini-css-extract-plugin
module.exports = {"content":"culture-header_content__9zXBA","title":"culture-header_title___9aG2"};